import React, { useCallback } from 'react'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { OfferPageActions, OfferPageMultiRoomMode } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  inputsName: string
  mode: OfferPageMultiRoomMode
}

function MultiRoomModeToggle({ inputsName, mode }: Props) {
  const dispatch = useOfferPageDispatch()

  const onModeChange = useCallback((mode: OfferPageMultiRoomMode) => {
    dispatch({ type: OfferPageActions.toggleMultiRoomMode, multiRoomMode: mode })
  }, [dispatch])

  return (
    <SegmentedOptionsGroup onValueChange={onModeChange} inputsName={inputsName}>
      <SegmentedOption
        title="Individually"
        value="individual"
        checked={mode === 'individual'}
      />
      <SegmentedOption
        title="Same for all rooms"
        value="same-room"
        checked={mode === 'same-room'}
      />
    </SegmentedOptionsGroup>
  )
}

export default withOfferPageState((state) => {
  return {
    mode: state.multiRoomMode,
  }
}, MultiRoomModeToggle)
